import { render, staticRenderFns } from "./subscribeProject.vue?vue&type=template&id=019c436c&scoped=true"
import script from "./subscribeProject.vue?vue&type=script&lang=js"
export * from "./subscribeProject.vue?vue&type=script&lang=js"
import style0 from "./subscribeProject.vue?vue&type=style&index=0&id=019c436c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019c436c",
  null
  
)

export default component.exports